import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export const initialQrCode = () => ({
  qrCodeList: [],
  qrCodeCount: 0,
  qrList: [],
  qrCount: 0,
  qrDetail: {},
  qrShops: [],
});

export default {
  state: initialQrCode(),
  mutations,
  actions,
  getters,
  namespaced: true,
};
